import instance from "../../middleware/HTTPInterceptors";
import ErrorResponse from "../../utilities/ErrorResponse";
import * as T from "../../utilities/frontendTypes";
import { getAuthHeader } from "../../utilities/helperFunctions";
import { apiGet, apiPost, apiPut } from "../apiClient";

/*
Membership Services
*/

export async function getMemberHeaders(): Promise<T.MembershipsResponse> {
  return apiGet<T.MembershipsResponse>("/api/admins/memberships");
}

export async function getMemberOwnerHeaders(): Promise<{success: boolean, ownerMembers: {rowKey: string, id: string, contact: string, companyName: string, date: Date, actionItem: string, stageChangedAt?: Date}[], name: string}> {
  return apiGet<{success: boolean, ownerMembers: {rowKey: string, id: string, contact: string, companyName: string, date: Date, actionItem: string, stageChangedAt?: Date}[], name: string}>("/api/admins/memberships-for-dashboard");
}

export async function getMemberDetails(id: T.UserId): Promise<T.MemberDetailsResponse> {
  return apiGet<T.MemberDetailsResponse>(`/api/admins/memberships/list/${id}`);
}

export async function changeTier(memberId: string, tier: number): Promise<T.HTTPResponse> {
  return apiPut<T.HTTPResponse>("/api/admins/memberships/change-tier", { memberId, tier });
}

export async function massStatusUpdate(userIds: string[], status: T.FounderStatus): Promise<T.HTTPResponse> {
  return apiPut<T.HTTPResponse>("/api/admins/mass-status-update", { userIds, status });
}

/*
Export Services
*/

export async function exportMembershipsCSV(params: {
  sections: string;
  applicationIds?: string[];
  status?: string;
  minDate?: string;
  maxDate?: string;
  cohort?: number;
}): Promise<Blob> {
  try {
    const config = {
      headers: await getAuthHeader(),
      responseType: 'blob' as const,
    };

    const res = await instance.post('/api/admins/memberships/export', params, config);

    if (res.status === 200) return res.data;

    throw new ErrorResponse("Export unsuccessful", 400);

  } catch (err: unknown) {
    const axiosErr = err as { response?: { data?: { message?: string }; status?: number } };
    throw new ErrorResponse(axiosErr.response?.data?.message || "Export failed", axiosErr.response?.status || 500);
  }
}


/*
Power Automate Sync (Invest Ottawa)
*/

export async function syncPowerAutomate(params: {
  applicationIds?: string[];
}): Promise<{ success: boolean; companiesSynced: number }> {
  return apiPost<{ success: boolean; companiesSynced: number }>("/api/admins/memberships/sync-power-automate", params);
}
